import { type SparePartOrderStatus } from './types';

export const TABS = { received: 'received', delivery: 'delivery', alert: 'alert' } as const;

export const DEFAULT_ACTIVE_TAB = TABS.received;

export const RECEIVED = 'RECEIVED';
const WAITING_VALIDATION = 'WAITING_VALIDATION';
const VALIDATED_WAITING_TO_BE_SENT = 'VALIDATED_WAITING_TO_BE_SENT';
export const CONFIRMED = 'CONFIRMED';
export const IN_TRUCK = 'IN_TRUCK';
export const PARTIALLY_RECEIVED = 'PARTIALLY_RECEIVED';
const PRECONFIRMED = 'PRECONFIRMED';
const SENT_TO_SUPPLIER = 'SENT_TO_SUPPLIER';

const STOCK_OUT = 'STOCK_OUT';
const CANCELED = 'CANCELED';
const ORDER_CANCELLED = 'ORDER_CANCELLED';

export const RECEIVED_ORDER_STATUS: SparePartOrderStatus[] = [RECEIVED];
export const DELIVERY_ORDER_STATUS: SparePartOrderStatus[] = [
  WAITING_VALIDATION,
  VALIDATED_WAITING_TO_BE_SENT,
  CONFIRMED,
  IN_TRUCK,
  PARTIALLY_RECEIVED,
  PRECONFIRMED,
  SENT_TO_SUPPLIER,
];
export const ALERT_ORDER_STATUS: SparePartOrderStatus[] = [STOCK_OUT, CANCELED, ORDER_CANCELLED];

export const ALL_ORDER_STATUSES = [RECEIVED_ORDER_STATUS, DELIVERY_ORDER_STATUS, ALERT_ORDER_STATUS].join(',');

export const SKELETON_LABEL = 'skeleton-label';
export const SKELETON_ITEM_CODE = 'skeleton-item-code';
export const SKELETON_IMAGE = 'skeleton-image';
export const SKELETON_QUANTITY = 'skeleton-quantity';
export const SKELETON_INTERVENTION = 'skeleton-intervention-id';
export const SKELETON_PRODUCT_LABEL = 'skeleton-product-label';
export const SKELETON_RECEIVED_DATE = 'skeleton-received-date';
export const SKELETON_DELIVERY_DATE = 'skeleton-delivery-date';
export const SKELETON_ROW = 'skeleton-row';

export const ORDER_STATUS_COLORS = {
  WAITING_VALIDATION: 'catchy',
  VALIDATED_WAITING_TO_BE_SENT: 'catchy',
  SENT_TO_SUPPLIER: 'catchy',
  PRECONFIRMED: 'catchy',
  CONFIRMED: 'catchy',
  STOCK_OUT: 'special',
  CANCELED: 'special',
  IN_TRUCK: 'catchy',
  PARTIALLY_RECEIVED: 'catchy',
  RECEIVED: 'neutral',
  ORDER_CANCELLED: 'special',
  INVALID_ORDER: 'special',
  ARCHIVED: 'special',
} as const;
